export const countSubscriptionDaysRemaining = (preiodEnd: string):number=>{
    const targetDate = new Date(preiodEnd);

    const currentDate = new Date();

    const timeDifference = targetDate.getTime() - currentDate.getTime();
  
    const daysRemaining = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysRemaining
}